/*绑定页面和登录页面相关
i:get || post
h:requestGet ||requestPost
*/
import axios from '../axios'
export default {
    getSmsToken: (data) => axios.post(`/api/api/get_sms_token`, data),//验证码获取手机号token
    getSmsCode: (data) => axios.post(`/api/api/get_sms_code`, data),//获取验证码
    getDoBind: (data) => axios.post(`/passport/user/doBind`, data),//绑定手机号
    getDoLogin: (data) => axios.requestPost(`/v1/logins/login`, data),//登录手机号

}